export default "__VITE_ASSET__DVdQEjL2__"